<template lang="pug">
.v-footer-cols.footer__cols(v-if="data")
	.footer__col(v-for="col in data.items")
		v-footer-collapse(:data="col")
			.footer__col-title {{col.title}}
			.footer__col-links(v-if="col.items")
				a.footer__col-link(v-for="itemLinks in col.items" :href="itemLinks.link") {{itemLinks.text}}

	.footer__col(v-if="data.contacts")
		v-footer-collapse(:data="data.contacts")
			.footer__col-title {{data.contacts.title}}
			slot(name="contacts")
	.footer__apps(v-if="data.apps")
		.footer__app(v-for="app in data.apps")
			img.footer__app-logo(:src="app.icon")
			.footer__app-content
				.footer__app-title(v-if="app.title") {{app.title}}
				.footer__app-subtitle(v-if="app.text") {{app.text}}
				.footer__app-actions
					v-app-widget(v-if="app.widget" :button="app.widget.button")
					a.btn.btn--xs(v-if="app.action" :href="app.action.link") {{app.action.text}}

</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],


	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}
</script>